export default {
    "notification": {
        "title": "Notifications",
        "showNotifications": "Show notifications",
        "hideNotifications": "Hide notifications",
        "clearNotifications": "Clear notifications",
    }
};
